// extracted by mini-css-extract-plugin
module.exports = {"popup-wrapper":"_6f25b66c20--popup-wrapper--2ykb1","popup-background":"_6f25b66c20--popup-background--3_4qA","popup":"_6f25b66c20--popup--1zJsU"};